export default "__VITE_ASSET__Be$IW6pd__"